import Vue from 'vue';
import {setReactiveStateValue} from "@/helperFunctions";
/*
export const setAuthState = (state, newState) => {
    state.authState = newState
};

*/

export const reset = (state) => {
	state.hasPerformedInitialLoad = false;
	state.isAuthorized = false;
	state.isWaitingForWhoami = false;
	state.authToken = '';
	state.displayName = '';
	state.rooms = {};
	state.currentRoom = false;
	state.products = {};
	state.spinTokens = false;
}

export const setPerformedInitialStateLoad = (state, newState) => {
	state.hasPerformedInitialLoad = newState
};

export const setIsAuthorized = (state, isAuthorized) => {
	state.isAuthorized = isAuthorized
};

export const setAuthToken = (state, token) => {
	state.authToken = token
};

export const setIsWaitingForWhoami = (state, whoami) => {
	state.isWaitingForWhoami = whoami
}

export const setDisplayName = (state, displayName) => {
	state.displayName = displayName
}


/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                ROOMS

 ************************************************************************/

export const updateRooms = (state, rooms) => {
	rooms.forEach((room) => {
		if(typeof state.rooms[room.room] === 'undefined')
		{
			setReactiveStateValue(state.rooms, room.room, room);
		}
		else
		{
			Object.keys(room).forEach((property) => {
				state.rooms[room.room][property] = room[property];
			});
		}
	});
}

export const deleteRooms = (state, rooms) => {
	rooms.forEach((room) => {
		Vue.delete(state.rooms, room);
	});
}

export const updateCurrentRoomPartial = (state,data) => {
	if(state.currentRoom !== false){
		Object.keys(data).forEach(property => {
			state.currentRoom[property] = data[property];
		})
	}
}

export const setCurrentRoom = (state, room) => {
	state.currentRoom = room;
}

export const addMessageToCurrentRoom = (state, message) => {
	if(state.currentRoom !== false && typeof state.currentRoom.messages !=='undefined')
	{
		let alreadyAdded = false;
		for(let i = 0; i < state.currentRoom.messages.length; i++){
			if(state.currentRoom.messages[i].id === message.id)
			{
				alreadyAdded = true;
				break;
			}
		}
		if(alreadyAdded === false)
			state.currentRoom.messages.push(message);
	}
}






/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                PRODUCTS

 ************************************************************************/

export const setProducts = (state, products) => {
	for(let i = 0; i < products.length; i++){
		setReactiveStateValue(state.products,products[i].id,products[i])
	}
};

export const setSearchProducts = (state, products) => {
	state.searchProducts = products;
};

export const addSearchProducts = (state, products) => {
	state.searchProducts = state.searchProducts.concat(products);
};

export const setNextSearchPage = (state, page) => {
	state.nextSearchPage = page;
};

export const setLocalSearchPage = (state, page) => {
	state.localSearchPage = page;
};

export const setSearchQuery = (state, searchQuery) => {
	state.searchQuery = searchQuery;
};

export const setSearchScroll = (state, searchScroll) => {
	state.searchScroll = searchScroll;
}




/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                KRAEMMER DATA

 ************************************************************************/

export const setKraemmerData = (state, data) =>
{
	setReactiveStateValue(state.kraemmerData,data.ggId,data)
};




/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                NOTIFICATIONS

 ************************************************************************/

export const setNotification = (state, notification) => {
	state.notification = notification;
}








/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                SPINS
 
 ************************************************************************/

export const setSpinTokens = (state, tokens) => {
	state.spinTokens = tokens;
}




/***********************************************************************
     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
                                TIL UX STORE

 ************************************************************************/

export const setPopupPrompt = (state,prompt) =>
{
	Object.keys(prompt).forEach((property) => {
		state.popupPrompt[property] = prompt[property]
	});
}

export const resetPopupPrompt = (state) =>
{
	state.popupPrompt = {
		title: '',
		prompt: '',
		callback: false,
		confirmValue: true,
		confirmText: 'Ja',
		denyValue: false,
		denyText: 'Nej',
		showCancelButton: true
	};
}
